module.exports = __webpack_public_path__ + "static/fonts/AppleSDGothicNeoR.caa84ba.woff";